import { OkrMetric } from "server/models"

export type OkrMetricValidation = { [key in keyof OkrMetric]?: string}
export interface OkrMetricList { [metricId: number]: OkrMetric }

export interface OkrMetricState {
    metricList: OkrMetricList
    metricIds: readonly number[]
    metricEdit: OkrMetric

    reloadList: boolean
    reloadEdit: boolean
}

export const OKR_METRIC_LIST = "OKR_METRIC_LIST"
export const OKR_METRIC_IDS = "OKR_METRIC_IDS"
export const OKR_METRIC_EDIT = "OKR_METRIC_EDIT"

export const OKR_METRIC_RELOAD_LIST = "OKR_METRIC_RELOAD_LIST"
export const OKR_METRIC_RELOAD_EDIT = "OKR_METRIC_RELOAD_EDIT"
